module.exports = __webpack_public_path__ + "static/media/sharebtn.1160c047.PNG";